<template>

<footer class="text-gray-900 py-10">
    <div class="container mx-auto px-6 lg:px-12">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        
         <!-- Contact Section -->
         <div>
          <h3 class="text-xl font-bold mb-4">Contact Us</h3>
          <p class="mb-2"><strong>Address:</strong> {{ contactInfo.address }}</p>
          <p><strong>Tel:</strong> {{ contactInfo.tel }}</p>  
          <!--  <p><strong>GSM:</strong> {{ contactInfo.gsm }}</p> --->
          <p><strong>Fax:</strong> {{ contactInfo.fax }}</p>
        </div>


        <div>
          <h3 class="text-xl font-bold mb-4 ">CONTACT US 7/24</h3>
          <ul class="space-y-2">
            <li v-for="(data, index) in emails" :key="index" class="flex">
              <img src="assets/mail.png" class="h-6 pr-2">  <a :href="`mailto:${data.mail}`" class="font-medium w-36">{{ data.mail }}</a>
            </li>
          </ul>
        </div>

      

        <div id="contactus">
         <ul class="space-y-2">
            <li v-for="(data, index) in menuItems" :key="index" class="flex">
            <a :href="data.url" class="font-medium">{{ data.text }} </a>
            </li>
          </ul>
        </div>
       
      </div>
      <div class="text-center mt-8 text-gray-400 text-sm">
        &copy; {{ new Date().getFullYear() }} All Rights Reserved.
      </div>
    </div>
  </footer>

</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

export default defineComponent({
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();
    const isOpen = ref(false);

    const emails= [
      //  { mail: "huseyin.karadayi@oceanlinkagency.com" },
        { mail: "operation@oceanlinkagency.com" },
        { mail: "account@oceanlinkagency.com" }
      ]
      const contactInfo= {
        address: "Maslak Mah. Maslak Meydan Sok. Beybi Giz Plaza No:1 Kat:15 D.No:55 PK:34398 Sarıyer İstanbul, Turkey",
        tel: "+90 212 9098603",
       // gsm: "+90 533 504 24 23",
        fax: "+90 850 522 3403"
      }

      const menuItems= [
        { text: "Ships Agency", url:"#shipagency" },
        { text: "Electronic Services", url:"#electoricservices" },
        { text: "Shipyard and repair", url:"#shipyard" },
        { text: "Financial Inspector", url:"#financial" }
      ]

    const logout = () => {
      authStore.logout();
      router.push('/');
    };

    router.afterEach(() => {
      isOpen.value = false;
    });

    return {
      authStore,
      isOpen,
      logout,
      emails,
      contactInfo,
      menuItems
    };
  },
});
</script>

<style scoped>
/* Stil tanımları */
</style>